import { styled } from "styled-components";

export const EditTournamentRemoteControlWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > .name {
    color: #121212;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
  }
`;

export const EditTournamentRemoteControl = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  > .button {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #e5e5e5;
    background: #fff;
  }

  > .count {
    display: flex;
    height: 44px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 14px;
    border: 1px solid #e5e5e5;
    background: #fff;
    color: #121212;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 19.2px */

    > span {
      color: #808080;
    }
  }
`;
